import React, { useState } from 'react';
import styled from 'styled-components';
import TaskSwitch from './TaskSwitch';
import UserMark from './TaskContainerElements/UserMark';

export default function TaskContainer(props) {
  const { taskID, type } = props;
  const [isMouseOver, setIsMouseOver] = useState(false);

  return (
    <Container
      className="pt-2"
      onMouseEnter={() => setIsMouseOver(true)}
      onMouseLeave={() => setIsMouseOver(false)}
    >
      <PreTask>
        <UserMark taskID={taskID} isMouseOver={isMouseOver} />
      </PreTask>
      <TaskSwitch type={type} taskID={taskID} />
    </Container>
  );
}

const Container = styled.div`
  display: grid;
  grid-template-columns: 24px 1fr;
`;

const PreTask = styled.div`
  height: 160px;
  display: flex;
  align-items: center;
`;
